import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface ISuperTableCreateSegmentDialogResult {
    segmentTitle: string;
    selectedColumns: INameId[];
}
